import React, { useEffect } from "react";
import Graph from "./components/Graph";

import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

const OutputEditorPage = () => {
  const location = useLocation();
  const fromRoomPlanner = location.state?.fromRoomPlanner === true;

  const selectedFloorPlan = useSelector(
    (state: RootState) => state.graph.selectedFloorPlan,
  );
  const graphData = useSelector((state: RootState) => state.graph.graphData);
  const floorplans = useSelector((state: RootState) => state.graph.floorPlans);
  const index = useSelector((state: RootState) => state.graph.index);
  const fromDocuments = useSelector(
    (state: RootState) => state.graph.fromDocuments,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !fromDocuments &&
      (!selectedFloorPlan || selectedFloorPlan.length === 0) &&
      floorplans &&
      floorplans[index]
    ) {
      console.log(
        "OutputEditorPage: Dispatching selectedFloorPlan from floorplans[index]",
        floorplans[index],
      );
      dispatch({
        type: "graph/setSelectedFloorPlan",
        payload: floorplans[index],
      });
    }
  }, [selectedFloorPlan, floorplans, index, dispatch, fromDocuments]);

  useEffect(() => {
    dispatch({ type: "outputEditorButtonState/setActiveTool", payload: "arrow" });
    dispatch({ type: "outputEditorButtonState/clearDrawLine" });
    dispatch({ type: "outputEditorButtonState/clearDrawDoor" });
    dispatch({ type: "outputEditorButtonState/clearDrawWindow" });
    dispatch({ type: "outputEditorButtonState/setAssetType", payload: null });
    dispatch({
      type: "outputEditorButtonState/setSelectedWall",
      payload: undefined,
    });
    dispatch({
      type: "outputEditorButtonState/setSelectedWallOption",
      payload: "select",
    });
  }, [dispatch]);

  useEffect(() => {
    console.log("Floorplans: ", floorplans);
    console.log("Selected Floor Plan:", selectedFloorPlan);
    console.log("Graph Data", graphData);
    console.log("fromRoomPlanner:", fromRoomPlanner);
  }, [selectedFloorPlan, floorplans, graphData, fromRoomPlanner]);

  return (
    <>
      <Graph fromRoomPlanner={fromRoomPlanner} />
    </>
  );
};

export default OutputEditorPage;

